// extracted by mini-css-extract-plugin
export default {"mixStepsBadge":"mix-steps_mixStepsBadge__uLTzr","iterationsCount":"mix-steps_iterationsCount__L11Rm","iteration":"mix-steps_iteration__hUR35","more":"mix-steps_more__iYgg1"};